const TYPE_PAID: string = 'paid'
const TYPE_DONATE: string = 'donate'
const TYPE_FREE: string = 'free'
const TYPE_EXTERNAL: string = 'external'
const BILLING_PREFERENCE_DEFAULT: string = 'default';
const BILLING_PREFERENCE_MP_LINKED_ACCOUNT: string = 'mpLinkedAccount';
const PAYMENT_COMPLETED = 'completed';
const ERROR = 'error';
const STATUS_DRAFT = 'draft';
const STATUS_REVISION = 'revision';
const STATUS_ACTIVE = 'active';
const STATUS_BLOCKED = 'blocked';
const STATUS_FINISHED = 'finished';


export {
    TYPE_PAID,
    TYPE_DONATE,
    TYPE_FREE,
    TYPE_EXTERNAL,
    BILLING_PREFERENCE_DEFAULT,
    BILLING_PREFERENCE_MP_LINKED_ACCOUNT,
    PAYMENT_COMPLETED,
    ERROR,
    STATUS_DRAFT,
    STATUS_REVISION,
    STATUS_ACTIVE,
    STATUS_BLOCKED,
    STATUS_FINISHED,
}